import angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';

/* prettier-ignore */
export const DowngradedUtilThoughtspotIntegratedModule = angular
  .module('downgraded-shared-util-thoughtspot-integrated', [])
  .service('ThoughtspotIntegrationService', downgradeInjectable(ThoughtspotIntegrationService))
  .name;
